import { createSlice } from '@reduxjs/toolkit'
import { IEventMilestone } from '../../types/EventMilestone'

export interface IEventMilestonesInitialState {
  data: IEventMilestone[]
  loading: boolean
  error: string
  selectedPwsId: string
}

const initialState: IEventMilestonesInitialState = {
  data: [] as IEventMilestone[],
  loading: false,
  error: '',
  selectedPwsId: '',
}

export const EventMilestonesSlice = createSlice({
  name: 'eventMilestones',
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },
  extraReducers: (builder) => {},
})

export const EventMilestonesActions = {
  ...EventMilestonesSlice.actions,
}

export const EventMilestonesReducer = EventMilestonesSlice.reducer
